/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import ResponsiveDrawer from "../Drawer/drawer";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { Form, Row, Col } from "react-bootstrap";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import axios from "axios";
import { BiSearch } from "react-icons/bi";
import Notification from "../AlertNotification/Message";
import ConfirmDialog from "../AlertNotification/confirmdialog";
import CircularIndeterminate from "../Loader/Loader";
////////////
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useReactToPrint } from "react-to-print";
import { TextField, InputAdornment } from "@mui/material";
import FilterColumnSelector from "../FilterColumnSelector";

////////////
const drawerWidth = 240;
const columns = [
  // {
  //   id: "img",
  //   label: "Avatar",
  //   minWidth: 100,
  //   align: "left",
  // },
  {
    id: "density",
    label: "Style Factory",
    minWidth: 200,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  {
    id: "name",
    label: "Sku",
    minWidth: 200,
    align: "left",
  },
  {
    id: "color",
    label: "Color",
    minWidth: 300,
    align: "left",
  },
  {
    id: "population",
    label: "Quantity",
    minWidth: 100,
    align: "left",
    sortable: true,
  },
];
//
const columnsTwo = [
  {
    id: "img",
    label: "",
    minWidth: 130,
    align: "left",
  },

  {
    id: "name",
    label: "",
    minWidth: 100,
    align: "left",
  },

  {
    id: "population",
    label: "Grand Total",
    minWidth: 100,
    align: "left",
  },
];
//
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

let newarr = [];

const filterableColumns = [
  { id: "sku", label: "SKU" },
  { id: "styleFactory", label: "Style Factory" },
  { id: "color_on_box", label: "Color" },
];

// Sortable Column Icon Component
const SortableColumnIcon = ({ isAscending, onClick, label }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {label}
      {isAscending ? (
        <ArrowUpwardIcon
          style={{
            marginLeft: "5px",
            fontSize: "16px",
            color: "#1976d2",
          }}
        />
      ) : (
        <ArrowDownwardIcon
          style={{
            marginLeft: "5px",
            fontSize: "16px",
            color: "#1976d2",
          }}
        />
      )}
    </div>
  );
};

function PairByStyle() {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Total Pairs By Style Name",
    // onAfterPrint: ()=> alert('Print success')
  });
  const navigate = useNavigate();
  //
  //
  const [show, setShow] = useState(true);
  const SortBy = () => {
    setShow(!show);
  };
  // -------//
  const HightTOLow = () => {
    customers.sort((c, d) => d.PairsSold - c.PairsSold);
    setShow(true);
  };
  // -------//
  const LowToHigh = () => {
    customers.sort((f, g) => f.PairsSold - g.PairsSold);
    setShow(true);
  };
  const storeName = () => {
    customers.sort((a, b) => a.storeName.localeCompare(b.storeName));
    setShow(true);

    // customers.sort((a, b) => a.sku.localeCompare(b.sku));
  };
  // -------//
  const SortDescending = () => {
    customers.sort((c, d) => c.PairsSold - d.PairsSold);
    setShow(true);
  };
  //
  //
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //
  const [One, setOne] = React.useState(null);
  //
  //   const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [filter, setfilter] = useState("");
  const [customers, setcustomers] = useState("");
  const [done, setdone] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(2000);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const [tokenauth, settokenauth] = useState("");
  const [reportdata, setreportdata] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState(
    filterableColumns.map((col) => col.id)
  );
  useEffect(() => {
    setdone(true);

    axios
      .post("get-token", {
        id: sessionStorage.getItem("token_id"),
      })
      .then((response) => {
        settokenauth(response.data.token);
        axios
          .post(
            "/sales-report",
            {},
            {
              headers: {
                "x-auth-header": response.data.token,
              },
            }
          )
          .then((response) => {
            setreportdata(response.data.mainArray);
            setcustomers(response.data.grandTotal);
            setdone(false);
          })
          .catch((err) => {
            console.log(err.response);
          });
      })
      .catch((err) => console.log(err));
  }, []);

  // Calculate filtered grand total whenever filter or selectedColumns change
  useEffect(() => {
    if (reportdata.length > 0) {
      let filteredTotal = 0;

      reportdata.forEach((admin) => {
        admin.forEach((data) => {
          if (data.styleFactory && data.sku && data.qty) {
            // Apply the same filtering logic as in the render
            if (filter === "") {
              filteredTotal += parseInt(data.qty) || 0;
            } else {
              const matchesFilter = selectedColumns.some((col) => {
                if (data[col]) {
                  return data[col]
                    .toString()
                    .toLowerCase()
                    .includes(filter.toString().toLowerCase());
                }
                return false;
              });

              if (matchesFilter) {
                filteredTotal += parseInt(data.qty) || 0;
              }
            }
          }
        });
      });

      setcustomers(filteredTotal);
    }
  }, [filter, selectedColumns, reportdata]);

  //
  const [sorat, setsorat] = useState(false);
  const [sorttotal, setsorttotal] = useState(false);
  const [qtySortAsc, setQtySortAsc] = useState(true); // true for asc (default), false for desc
  const asendsort = () => {
    setsorat(false);

    const finalArray = [];

    reportdata.sort((a, b) => {
      const num1 = a[0].styleFactory.split("-")[0];
      const num2 = b[0].styleFactory.split("-")[0];
      if (num1 < num2) return -1;
      if (num1 > num2) return 1;
      return 0;
    });

    reportdata.forEach((item) => {
      if (finalArray.length == 0) {
        const tempArray = reportdata.filter((inner_item) => {
          return (
            inner_item[0].styleFactory.split("-")[0] ==
            item[0].styleFactory.split("-")[0]
          );
        });
        finalArray.push(tempArray);
      } else {
        const findData = finalArray.find((a) => {
          return (
            a[0][0].styleFactory.split("-")[0] ==
            item[0].styleFactory.split("-")[0]
          );
        });

        if (!findData) {
          const tempArray = reportdata.filter((inner_item) => {
            return (
              inner_item[0].styleFactory.split("-")[0] ==
              item[0].styleFactory.split("-")[0]
            );
          });
          finalArray.push(tempArray);
        }
      }
    });

    finalArray.forEach((item) => {
      item.sort((a, b) => {
        const num1 = a[0].styleFactory.split("-")[1];
        const num2 = b[0].styleFactory.split("-")[1];
        if (num1 < num2) return -1;
        if (num1 > num2) return 1;
        return 0;
      });
    });

    const finalarr = [];

    console.log(finalArray);
    finalArray.map((data) => data.map((odata) => finalarr.push(odata)));
    console.log(finalarr);
    setreportdata(finalarr);
  };
  const desendsort = () => {
    setsorat(true);

    const finalArray = [];

    reportdata.sort((a, b) => {
      const num1 = a[0].styleFactory.split("-")[0];
      const num2 = b[0].styleFactory.split("-")[0];
      if (num1 < num2) return 1;
      if (num1 > num2) return -1;
      return 0;
    });

    reportdata.forEach((item) => {
      if (finalArray.length == 0) {
        const tempArray = reportdata.filter((inner_item) => {
          return (
            inner_item[0].styleFactory.split("-")[0] ==
            item[0].styleFactory.split("-")[0]
          );
        });
        finalArray.push(tempArray);
      } else {
        const findData = finalArray.find((a) => {
          return (
            a[0][0].styleFactory.split("-")[0] ==
            item[0].styleFactory.split("-")[0]
          );
        });

        if (!findData) {
          const tempArray = reportdata.filter((inner_item) => {
            return (
              inner_item[0].styleFactory.split("-")[0] ==
              item[0].styleFactory.split("-")[0]
            );
          });
          finalArray.push(tempArray);
        }
      }
    });

    finalArray.forEach((item) => {
      item.sort((a, b) => {
        const num1 = a[0].styleFactory.split("-")[1];
        const num2 = b[0].styleFactory.split("-")[1];
        if (num1 < num2) return 1;
        if (num1 > num2) return -1;
        return 0;
      });
    });

    const finalarr = [];

    console.log(finalArray);
    finalArray.map((data) => data.map((odata) => finalarr.push(odata)));
    console.log(finalarr);
    setreportdata(finalarr);
  };
  // const asendsort = () => {
  //   setsorat(false);
  //   // console.log(reportdata);
  //   const a = [];
  //   const b = [];
  //   const c = [];
  //   const d = [];
  //   const e = [];
  //   const f = [];
  //   const g = [];
  //   const h = [];
  //   const i = [];
  //   const j = [];
  //   const k = [];
  //   const l = [];
  //   const m = [];
  //   const n = [];
  //   const o = [];
  //   const p = [];
  //   const q = [];
  //   const r = [];
  //   const s = [];
  //   const t = [];
  //   const u = [];
  //   const v = [];
  //   const w = [];
  //   const x = [];
  //   const y = [];
  //   const z = [];
  //   let albhabets = [
  //     "a",
  //     "b",
  //     "c",
  //     "d",
  //     "e",
  //     "f",
  //     "g",
  //     "h",
  //     "i",
  //     "j",
  //     "k",
  //     "l",
  //     "m",
  //     "n",
  //     "o",
  //     "p",
  //     "q",
  //     "r",
  //     "s",
  //     "t",
  //     "u",
  //     "v",
  //     "w",
  //     "x",
  //     "y",
  //     "z",
  //   ];
  //   const updatedarr = reportdata.sort((a, b) => {
  //     let fa = a[0].styleFactory.split("-")[1].toLowerCase(),
  //       fb = b[0].styleFactory.split("-")[1].toLowerCase();

  //     if (fa < fb) {
  //       return -1;
  //     }
  //     if (fa > fb) {
  //       return 1;
  //     }
  //     return 0;
  //   });
  //   // console.log(updatedarr);
  //   let sortByAphabetArrays = [];
  //   albhabets.forEach((item) => {
  //     updatedarr.filter((x) => {
  //       x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //       item === "a"
  //         ? a.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "b"
  //         ? b.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "c"
  //         ? c.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "d"
  //         ? d.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "e"
  //         ? e.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "f"
  //         ? f.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "g"
  //         ? g.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "h"
  //         ? h.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "i"
  //         ? i.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "j"
  //         ? j.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "k"
  //         ? k.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "l"
  //         ? l.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "m"
  //         ? m.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "n"
  //         ? n.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "o"
  //         ? o.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "p"
  //         ? p.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "q"
  //         ? q.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "r"
  //         ? r.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "s"
  //         ? s.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "t"
  //         ? t.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "u"
  //         ? u.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "v"
  //         ? v.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "w"
  //         ? w.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "x"
  //         ? x.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "y"
  //         ? y.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "z" &&
  //           z.push(x);
  //     });
  //   });
  //   sortByAphabetArrays.push(
  //     a.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     b.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     c.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     d.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     e.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     f.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     g.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     h.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     i.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     j.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     k.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     l.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     m.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     n.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     o.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     p.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     q.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     r.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     s.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     t.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     u.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     v.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     w.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     x.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     y.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     }),
  //     z.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return -1;
  //       }
  //       if (fa > fb) {
  //         return 1;
  //       }
  //       return 0;
  //     })
  //   );
  //   const sortedarr = [];
  //   sortByAphabetArrays.map((data) => data.map((arr) => sortedarr.push(arr)));
  //   setreportdata(sortedarr);
  // };

  // const desendsort = () => {
  //   setsorat(true);
  //   // console.log(reportdata);
  //   const a = [];
  //   const b = [];
  //   const c = [];
  //   const d = [];
  //   const e = [];
  //   const f = [];
  //   const g = [];
  //   const h = [];
  //   const i = [];
  //   const j = [];
  //   const k = [];
  //   const l = [];
  //   const m = [];
  //   const n = [];
  //   const o = [];
  //   const p = [];
  //   const q = [];
  //   const r = [];
  //   const s = [];
  //   const t = [];
  //   const u = [];
  //   const v = [];
  //   const w = [];
  //   const x = [];
  //   const y = [];
  //   const z = [];
  //   let albhabets = [
  //     "a",
  //     "b",
  //     "c",
  //     "d",
  //     "e",
  //     "f",
  //     "g",
  //     "h",
  //     "i",
  //     "j",
  //     "k",
  //     "l",
  //     "m",
  //     "n",
  //     "o",
  //     "p",
  //     "q",
  //     "r",
  //     "s",
  //     "t",
  //     "u",
  //     "v",
  //     "w",
  //     "x",
  //     "y",
  //     "z",
  //   ];
  //   const updatedarr = reportdata.sort((a, b) => {
  //     let fa = a[0].styleFactory.split("-")[1].toLowerCase(),
  //       fb = b[0].styleFactory.split("-")[1].toLowerCase();

  //     if (fa < fb) {
  //       return 1;
  //     }
  //     if (fa > fb) {
  //       return -1;
  //     }
  //     return 0;
  //   });
  //   // console.log(updatedarr);
  //   let sortByAphabetArrays = [];
  //   albhabets.reverse().forEach((item) => {
  //     updatedarr.filter((x) => {
  //       x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //       item === "a"
  //         ? a.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "b"
  //         ? b.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "c"
  //         ? c.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "d"
  //         ? d.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "e"
  //         ? e.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "f"
  //         ? f.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "g"
  //         ? g.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "h"
  //         ? h.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "i"
  //         ? i.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "j"
  //         ? j.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "k"
  //         ? k.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "l"
  //         ? l.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "m"
  //         ? m.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "n"
  //         ? n.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "o"
  //         ? o.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "p"
  //         ? p.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "q"
  //         ? q.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "r"
  //         ? r.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "s"
  //         ? s.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "t"
  //         ? t.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "u"
  //         ? u.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "v"
  //         ? v.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "w"
  //         ? w.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "x"
  //         ? x.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "y"
  //         ? y.push(x)
  //         : x[0].styleFactory.split("-")[1].toLowerCase().startsWith(item) &&
  //           item === "z" &&
  //           z.push(x);
  //     });
  //   });
  //   sortByAphabetArrays.push(
  //     a.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     b.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     c.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     d.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     e.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     f.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     g.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     h.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     i.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     j.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     k.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     l.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     m.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     n.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     o.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     p.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     q.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     r.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     s.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     t.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     u.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     v.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     w.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     x.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     y.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     }),
  //     z.sort((a, b) => {
  //       let fa = a[0].styleFactory.split("-")[0].toLowerCase(),
  //         fb = b[0].styleFactory.split("-")[0].toLowerCase();

  //       if (fa < fb) {
  //         return 1;
  //       }
  //       if (fa > fb) {
  //         return -1;
  //       }
  //       return 0;
  //     })
  //   );
  //   // console.log("sortByAphabetArrays", sortByAphabetArrays);
  //   const sortedarr = [];
  //   sortByAphabetArrays
  //     .reverse()
  //     .map((data) => data.map((arr) => sortedarr.push(arr)));
  //   // console.log("sorted", sortedarr);
  //   setreportdata(sortedarr);
  // };

  const asendsorttotal = () => {
    // console.log("assend");
    setsorttotal(false);
    setQtySortAsc(true); // Update icon state to ascending
  };
  // const desendsort = () => {
  //   setsorat(true);
  //   console.log(reportdata);

  //   reportdata.sort((a, b) => {
  //     let fa = a[0].styleFactory.split("-")[1].toLowerCase(),
  //       fb = b[0].styleFactory.split("-")[1].toLowerCase();

  //     if (fa < fb) {
  //       return 1;
  //     }
  //     if (fa > fb) {
  //       return -1;
  //     }
  //     return 0;
  //   });
  // };
  const desendsorttotal = () => {
    setsorttotal(true);
    setQtySortAsc(false); // Update icon state to descending
  };

  // Toggle function for quantity sort in column header
  const toggleQuantitySort = () => {
    setQtySortAsc(!qtySortAsc);
  };
  //
  //
  return (
    <div className="tableX">
      <ResponsiveDrawer heading="Reports" />
      <Box
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
        component="main"
      >
        <Toolbar />

        <div className="position-relative mt-5">
          <div className="d-flex justify-content-between mx-4 overflow-x-scroll">
            <div>
              <Button
                id="demo-customized-button"
                aria-controls="demo-customized-menu"
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                // variant="contained"
                disableElevation
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon style={{ color: "#f00e0e" }} />}
              >
                <span className="fw-bolder text-dark">
                  Total&nbsp;Pairs&nbsp;by&nbsp;Style&nbsp;Name
                </span>
              </Button>
              <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                  "aria-labelledby": "demo-customized-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                <MenuItem
                  disableRipple
                  // eslint-disable-next-line react/jsx-no-duplicate-props
                  onClick={() => {
                    navigate("/AllStyleSold");
                  }}
                >
                  All&nbsp;Styles&nbsp;Sold
                </MenuItem>
                <MenuItem
                  disableRipple
                  // eslint-disable-next-line react/jsx-no-duplicate-props
                  onClick={() => {
                    navigate("/TotalSales");
                  }}
                >
                  Total&nbsp;Sales&nbsp;by&nbsp;Date
                </MenuItem>
                <MenuItem
                  disableRipple
                  // eslint-disable-next-line react/jsx-no-duplicate-props
                  onClick={() => {
                    navigate("/SalesByStyleFactory");
                  }}
                >
                  Total&nbsp;Sales&nbsp;by&nbsp;StyleFactory
                </MenuItem>
                <MenuItem
                  disableRipple
                  // eslint-disable-next-line react/jsx-no-duplicate-props
                  onClick={() => {
                    navigate("/StoreOrderStatus");
                  }}
                >
                  Store&nbsp;Order&nbsp;Status
                </MenuItem>
                <Divider sx={{ my: 0.5 }} />
                <MenuItem
                  disableRipple
                  // eslint-disable-next-line react/jsx-no-duplicate-props
                  onClick={() => {
                    navigate("/SalesByStore");
                  }}
                >
                  Total&nbsp;Sales&nbsp;by&nbsp;Store&nbsp;Name
                </MenuItem>
                <MenuItem
                  disableRipple
                  // eslint-disable-next-line react/jsx-no-duplicate-props
                  onClick={() => {
                    navigate("/FactoryStyleByStoreName");
                  }}
                >
                  Factory&nbsp;Style&nbsp;by&nbsp;Store&nbsp;Name
                </MenuItem>
                <MenuItem
                  disableRipple
                  // eslint-disable-next-line react/jsx-no-duplicate-props
                  onClick={() => {
                    navigate("/TotalPairsByStyle");
                  }}
                >
                  Total&nbsp;Pairs&nbsp;by&nbsp;Style&nbsp;Name
                </MenuItem>
              </StyledMenu>
            </div>

            <div className="d-flex gap-3">
              <div>
                {sorat ? (
                  <Button
                    variant="contained"
                    endIcon={<ArrowUpwardIcon />}
                    onClick={asendsort}
                    className="cursor backgrnd"
                    color="info"
                  >
                    Sort&nbsp;Style&nbsp;Factory
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    endIcon={<ArrowDownwardIcon />}
                    onClick={desendsort}
                    className="cursor backgrnd"
                    color="info"
                  >
                    Sort&nbsp;Style&nbsp;Factory
                  </Button>
                )}
              </div>
              <div className="ml-3">
                {sorttotal ? (
                  <Button
                    variant="contained"
                    endIcon={<ArrowUpwardIcon />}
                    onClick={asendsorttotal}
                    className="cursor backgrnd"
                    color="info"
                  >
                    Quantity
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    endIcon={<ArrowDownwardIcon />}
                    onClick={desendsorttotal}
                    className="cursor backgrnd"
                    color="info"
                  >
                    Quantity
                  </Button>
                )}
              </div>
              <div className="position-relative ms-3 w-100">
                {/* <div className="d-flex align-items-center ms-3 gap-2"> */}

                <Form onSubmit={(e) => e.preventDefault()}>
                  <Form.Control
                    placeholder="Search by Sku, style factory, color"
                    type="search"
                    className="input_field"
                    onChange={(e) => setfilter(e.target.value)}
                  />
                  <BiSearch className="search_Agent1" />
                </Form>
                <FilterColumnSelector
                  filterableColumns={filterableColumns}
                  selectedColumns={selectedColumns}
                  setSelectedColumns={setSelectedColumns}
                  placeholder="Select columns to filter by..."
                  minWidth="200px"
                  maxWidth="300px"
                />
                {/* </div> */}
                {/* <Form>
                  <Form.Control
                    placeholder="Search by Sku, style factory, color"
                    type="search"
                    className="input_field"
                    onChange={(e) => setfilter(e.target.value)}
                  />
                  <BiSearch className="search_Agent1" />
                </Form> */}
              </div>
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-end m-4">
            <div>
              <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="ms-3 py-2 px-3 ExcelDownlad download-table-xls-button"
                table="table-to-xls"
                filename="Total Pairs By Style Name"
                sheet="Total Pairs By Style Name"
                buttonText="Export&nbsp;CSV"
                size="small"
              />
            </div>
            <div>
              <Button
                variant="contained"
                // endIcon={<ArrowUpwardIcon />}
                onClick={handlePrint}
                className="cursor backgrnd"
                color="info"
              >
                Download&nbsp;PDF
              </Button>
            </div>
          </div>
          {done ? (
            <CircularIndeterminate className="reportsales" />
          ) : (
            <div className="for__table m-4">
              <Paper sx={{ width: "100%", overflow: "hidden" }}>
                <TableContainer sx={{ maxHeight: 730 }}>
                  <Table
                    stickyHeader
                    aria-label="sticky table"
                    id="table-to-xls"
                    ref={componentRef}
                  >
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                          >
                            {column.label === "Quantity" ? (
                              <SortableColumnIcon
                                isAscending={qtySortAsc}
                                onClick={toggleQuantitySort}
                                label={column.label}
                              />
                            ) : (
                              column.label
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    {reportdata.length > 0 ? (
                      reportdata
                        .map((admin) => {
                          // Separate regular data from total quantity rows
                          const regularData = admin.filter(
                            (item) => item.styleFactory && item.sku && item.qty
                          );
                          const totalQtyData = admin.filter(
                            (item) => item.totalQty
                          );

                          // Sort only the regular data
                          const sortedRegularData = regularData.sort((a, b) => {
                            const aQty = parseInt(a.qty) || 0;
                            const bQty = parseInt(b.qty) || 0;
                            return qtySortAsc ? aQty - bQty : bQty - aQty;
                          });

                          // Return sorted regular data followed by total quantity data
                          return [...sortedRegularData, ...totalQtyData];
                        })
                        .map((admin) => {
                          return (
                            admin
                              .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                              // eslint-disable-next-line array-callback-return
                              .filter((admins) => {
                                if (filter === "") {
                                  return true;
                                }
                                // Only filter on selected columns
                                return selectedColumns.some((col) => {
                                  if (admins[col]) {
                                    return admins[col]
                                      .toString()
                                      .toLowerCase()
                                      .includes(
                                        filter.toString().toLowerCase()
                                      );
                                  }
                                  return false;
                                });
                              })
                              .map((data) => (
                                <>
                                  <TableBody>
                                    {data.styleFactory &&
                                    data.sku &&
                                    data.qty ? (
                                      <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={data.sku}
                                      >
                                        <TableCell>
                                          {data.styleFactory &&
                                            data.styleFactory}
                                        </TableCell>
                                        <TableCell>
                                          {data.sku && data.sku}
                                        </TableCell>
                                        <TableCell>
                                          {data.color_on_box &&
                                            data.color_on_box}
                                        </TableCell>
                                        <TableCell>
                                          {data.qty && data.qty}
                                        </TableCell>
                                      </TableRow>
                                    ) : null}
                                  </TableBody>

                                  <TableBody className="bger">
                                    {data.totalQty ? (
                                      <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={data.sku}
                                      >
                                        <TableCell className="fw-bold">
                                          Total Quantity
                                        </TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell className="fw-bold">
                                          {data.totalQty}
                                        </TableCell>
                                      </TableRow>
                                    ) : null}
                                  </TableBody>
                                </>
                              ))
                          );
                        })
                    ) : (
                      <h5 className="text-center mt-5 fw-bolder">No Data</h5>
                    )}
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        {columnsTwo.map((column) => (
                          <TableCell
                            className="fw-bolder"
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                      <TableRow hover role="checkbox" tabIndex={-1}>
                        <TableCell className="text-light"></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell>{customers}</TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                </TableContainer>
                <TablePagination
                  className="mx-5 mt-3 px-5"
                  rowsPerPageOptions={[2000, 5000, 8000]}
                  component="div"
                  count={reportdata.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </div>
          )}
        </div>
      </Box>
      <Notification notify={notify} setNotify={setNotify} />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </div>
  );
}

export default PairByStyle;
